'use client';

import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import OrderRecordAndActionStateHandler from 'src/utils/OrderRecordAndActionMatcher';
import { needsDataRequirement } from 'src/utils/routeDataRequirements';

export const OrderMatcherContext = createContext<
	OrderRecordAndActionStateHandler | undefined
>(undefined);

const OrderRecordMatcherProvider = (props: PropsWithChildren<any>) => {
	const pathname = usePathname();
	const [handler, setHandler] = useState<
		OrderRecordAndActionStateHandler | undefined
	>();

	const isConnected = useWalletIsConnected();

	// Check if current route needs order matching and market history
	// Enable on trading pages and stats pages where order history is shown
	const needsOrderMatching = pathname
		? needsDataRequirement(pathname, 'trading') ||
			needsDataRequirement(pathname, 'stats')
		: false;

	useEffect(() => {
		if (!needsOrderMatching) {
			setHandler(undefined);
			return;
		}

		setHandler(new OrderRecordAndActionStateHandler());
		return;
	}, [isConnected, needsOrderMatching]);

	return (
		<OrderMatcherContext value={handler}>{props.children}</OrderMatcherContext>
	);
};

export default OrderRecordMatcherProvider;
